const translations = {
    activeIngredients: 'Active ingredients',
    addChemical: '+ Add Chemical',
    documentEntryWithDescription: '{{entry}} · {{description}}',
    epaNumber: 'EPA {{epaNumber}}',
    expired: 'Expired',
    hideDetails: 'Hide details',
    labelCheck: 'Label check',
    labelCheckAboveMax: 'Above max {{rate}}',
    labelCheckCheckUnit: 'Check unit',
    labelCheckMax: 'Max {{rate}}',
    labelCheckMaxPerAmount: 'Max {{rate}} per {{perAmount}}',
    labelCheckMaxVariesByUse: 'Max varies by use: {{lowestRate}}–{{highestRate}}',
    labelCheckNoLabelData: 'No label data',
    labelCheckNotLabeled: 'Not labeled',
    labelCheckSeeLabel: 'See label',
    labelEntry: 'Label {{position}}',
    labelUnitAcre: 'ac',
    labelUnitCount: 'unit',
    labelUnitFluidOunce: 'fl oz',
    labelUnitFluidOuncesPerAcre: 'fl oz/ac',
    labelUnitGallon: 'gal',
    labelUnitGallonsPerAcre: 'gal/ac',
    labelUnitGram: 'g',
    labelUnitHectare: 'ha',
    labelUnitKilogram: 'kg',
    labelUnitKilogramsPerSquareMeter: 'kg/m²',
    labelUnitLiter: 'L',
    labelUnitMilligram: 'mg',
    labelUnitMilliliter: 'mL',
    labelUnitOunce: 'oz',
    labelUnitOuncesPerAcre: 'oz/ac',
    labelUnitPint: 'pt',
    labelUnitPintsPerAcre: 'pt/ac',
    labelUnitPound: 'lb',
    labelUnitPoundsPerAcre: 'lb/ac',
    labelUnitQuart: 'qt',
    labelUnitQuartsPerAcre: 'qt/ac',
    labelUnitShortTon: 'ton',
    labelUnitSquareFoot: 'sq ft',
    labelUnitSquareMeter: 'm²',
    labelUnitSquareYard: 'sq yd',
    noProducts: 'No products yet. Add the first product in the mix.',
    notSet: 'Not set',
    product: 'Product',
    productPosition: 'Product {{position}}',
    rate: 'Rate',
    removeProduct: 'Remove {{productName}}',
    safetyDataSheetEntry: 'SDS {{position}}',
    showDetails: 'Show details',
    signalWord: 'Signal word',
    targetPest: 'Target pest',
    title: 'Tank mix',
    unitFluidOuncesPerAcre: 'Fl. Oz/Ac',
    unitGallonsPerAcre: 'Ga/Ac',
    unitKilogramsPerSquareMeter: 'Kg/m²',
    unitOuncesPerAcre: 'Oz/Ac',
    unitPintsPerAcre: 'Pt/Ac',
    unitPoundsPerAcre: 'Lb/Ac',
    unitQuartsPerAcre: 'Qt/Ac',
    useLabelMax: 'Use label max',
    viewLabel: 'View label',
    viewLabels: 'View labels ({{documentCount}})',
    viewSafetyDataSheet: 'View SDS',
    viewSafetyDataSheets: 'View SDS ({{documentCount}})'
};

export default translations;
